<template>
  <div>
    <h2 class="step-name">Mastitis Control Measures</h2>
		<div class="alert alert-success">
			Most of this step is optional except for 3 data fields at the bottom of
			the page - click <a @click="scrolltomandatoryfields">here</a> to go directly to these
			fields.
		</div>
    <div class="step-section">
      <div class="clearfix" :style="{ width: 400 + widthForRow(getFieldValue('FARMS')) + 'px' }">

        <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
          <h3>{{ farm.farm_label }}</h3>

          <text-input label="Shed type"
                      :field-name="`farm_${farm.id}-shed_type`"
                      disabled>
          </text-input>

          <text-input label="Bales"
                      :field-name="`farm_${farm.id}-bales`"
                      disabled>
          </text-input>
          <radio-input label="Cows milk out well?"
                       :field-name="`farm_${farm.id}-do_cows_milk_well`"
                       :choices="[
                                 {value: 'Yes', display: 'Yes'},
                                 {value: 'No', display: 'No'},
                                 ]"
                       :disabled="isReadOnly">
          </radio-input>


          <div class="comments">
            <span class="form-group">
              <label for="mcm_teat_condition">Teat condition</label>
              <comments :field-name="`farm_${farm.id}-mcm_teat_condition`" :isReadOnly="isReadOnly">
              </comments>
            </span>
          </div>

          <div class="comments">
            <span class="form-group">
              <label for="mcm_teat_spraying_product_used">Teat spraying product used</label>
              <comments :field-name="`farm_${farm.id}-mcm_teat_spraying_product_used`" :isReadOnly="isReadOnly">
              </comments>
            </span>
          </div>

          <radio-input label="Application"
                       :field-name="`farm_${farm.id}-teat_application`"
                       :choices="[
                                 {value: 'Automatic', display: 'Automatic'},
                                 {value: 'Manual', display: 'Manual'},
                                 ]"
                       :disabled="isReadOnly">
          </radio-input>

          <div class="comments">
            <span class="form-group">
              <label for="mcm_comments_on_concentration_or_application">Comments on concentration or application</label>
              <comments :field-name="`farm_${farm.id}-mcm_comments_on_concentration_or_application`" :isReadOnly="isReadOnly">
              </comments>
            </span>
          </div>

          <radio-input label="Annual Machine check?"
                       :field-name="`farm_${farm.id}-does_annual_machine_check`"
                       :choices="[
                                 {value: 'Yes', display: 'Yes'},
                                 {value: 'No', display: 'No'},
                                 ]"
                       :disabled="isReadOnly">
          </radio-input>


          <radio-input label="Scheduled rubber ware checks?"
                       :field-name="`farm_${farm.id}-does_rubber_checks`"
                       :choices="[
                                 {value: 'Yes', display: 'Yes'},
                                 {value: 'No', display: 'No'},
                                 ]"
                       :disabled="isReadOnly">
          </radio-input>

          <text-input label="If YES, how often?"
                      :field-name="`farm_${farm.id}-rubber_checks_how_often`"
                      :disabled="isReadOnly">
          </text-input>


          <text-input label="Frequency liners are changed"
                      :field-name="`farm_${farm.id}-liner_change_frequency`"
                      :disabled="isReadOnly">
          </text-input>

        </div>
      </div>
    </div>

    <h2 class="step-name">Detection and Treatment of Clinical Cases</h2>
    <div class="step-section">
      <div class="clearfix" :style="{ width: 400 + widthForRow(getFieldValue('FARMS')) + 'px' }">

        <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
          <h3>{{ farm.farm_label }}</h3>

          <radio-input label="Whole herd regularly stripped for clinical cases?"
                       :field-name="`farm_${farm.id}-is_herd_stripped_clinical_cases`"
                       :choices="[
                                  {value: 'Yes', display: 'Yes'},
                                  {value: 'No', display: 'No'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

          <radio-input label="Mastitis cows managed in a penicillin mob?"
                       :field-name="`farm_${farm.id}-mastitis_cows_in_penicillin_mob`"
                       :choices="[
                                  {value: 'Yes', display: 'Yes'},
                                  {value: 'No', display: 'No'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

          <radio-input label="If YES, milking frequency?"
                       :field-name="`farm_${farm.id}-mastitis_mob_milk_freq`"
                       :choices="[
                                  {value: 'OAD', display: 'OAD'},
                                  {value: 'TAD', display: 'TAD'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

          <radio-input label="Teat wipes used when inserting intramammaries?"
                       :field-name="`farm_${farm.id}-are_teat_wipes_used`"
                       :choices="[
                                  {value: 'Yes', display: 'Yes'},
                                  {value: 'No', display: 'No'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

					<div class="mandatory-fields">
						<number-input label="Number of inhibitory substance grades"
							:field-name="`farm_${farm.id}-num_inhibitory_substance_grades`"
							:disabled="isReadOnly">
						</number-input>

						<number-input label="Number of near misses"
							:field-name="`farm_${farm.id}-num_near_misses`"
							:disabled="isReadOnly">
						</number-input>

						<span class="form-group">
							<label for="detection_and_treatment_of_clinical_cases">Comments</label>
							<comments :field-name="`farm_${farm.id}-detection_and_treatment_of_clinical_cases`"
								:isReadOnly="isReadOnly">
							</comments>
						</span>
					</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'MastitisControlMeasures',
  mixins: [ baseComponent ],
	methods: {
		scrolltomandatoryfields: function () {
      document
        .querySelector(".mandatory-fields")
        .scrollIntoView({ behavior: "smooth" });
		}
	}
};
</script>
<style>
.mandatory-fields {
	border: 2px solid rgba(255, 0, 0, .7);
	border-radius: 5px;
}
</style>
